export const VIDEOMAIL_CAMERA_WAIT_MS = 10000;
/**
 * How long to wait for the recorder to confirm it is capturing before
 * treating the take as running anyway. The recorder needs roughly ten
 * seconds to launch its browser, join and start encoding, and it announces
 * that with an "on" status. If that announcement is ever lost, the take must
 * still become stoppable and saveable rather than stranding the recording
 * behind a status that will never arrive.
 */
export const VIDEOMAIL_RECORDER_ON_WAIT_MS = 12000;
/**
 * Separates camera readiness from recorder readiness, and being assigned a
 * recorder from being recorded by one.
 *
 * The recorder is assigned within a second or so of the request but does not
 * capture anything for about ten seconds after that, so treating assignment
 * as "recording" told people they were on camera while nothing was being
 * written. `arming` is that gap. Once a take is confirmed, it stays
 * `recording` even if the local camera track is later muted, replaced or
 * removed, so the stop control never disappears mid-take.
 *
 * @param {IVideoMailCaptureState} state - Camera and recorder readiness.
 * @returns {VideoMailCapturePhase} The current recorder-control phase.
 */
export function getVideoMailCapturePhase({ cameraReady, cameraWaitExpired, recorderConfirmed = true, recordingSessionId }) {
    if (recordingSessionId) {
        return recorderConfirmed ? 'recording' : 'arming';
    }
    if (cameraReady) {
        return 'starting';
    }
    return cameraWaitExpired ? 'camera-unavailable' : 'waiting';
}
